/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SchemaDefinition } from '../../openapi/v3/models/Oas30SchemaDefinition';
import { DeleteSchemaDefinitionCommand } from './DeleteSchemaDefinitionCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteSchemaDefinitionCommand
 * @class
 */
export class DeleteSchemaDefinitionCommand_30 extends DeleteSchemaDefinitionCommand {
    public constructor(definitionName? : any) {
        if(((typeof definitionName === 'string') || definitionName === null)) {
            let __args = arguments;
            super(definitionName);
        } else if(definitionName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand#doDeleteSchemaDefinition(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteSchemaDefinition(document : Document) : any {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(ModelUtils.isDefined(doc30.components)) {
            let oldDef : Oas30SchemaDefinition = doc30.components.removeSchemaDefinition(this._definitionName);
            return Library.writeNode(oldDef);
        }
        return null;
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand#doRestoreSchemaDefinition(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} document
     * @param {*} oldDefinition
     */
    doRestoreSchemaDefinition(document : Document, oldDefinition : any) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(ModelUtils.isDefined(doc30.components)) {
            let schemaDef : Oas30SchemaDefinition = doc30.components.createSchemaDefinition(this._definitionName);
            Library.readNode(oldDefinition, schemaDef);
            doc30.components.addSchemaDefinition(this._definitionName, schemaDef);
        }
    }
}
DeleteSchemaDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSchemaDefinitionCommand_30";
DeleteSchemaDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




